<template>
  <div class="nav-container">
    <div :class="sign==1?'head-top':'head-top public-width'" style="padding-top:0;">
      <el-row style="">
        <!-- <div class="head-top-box fx"> -->
          <el-col :span="10">
            <div class="head-top-school fx" @click="goHome">
              <img v-if="schoolInfo.logoUrl" :src="$config.baseImgURL+'Article/showPhotograph/'+schoolInfo.logoUrl" alt="">
              <img v-else src="../assets/schoolLogo.jpg" alt="">
              
              <h3 v-if="schoolInfo.fullName" :style="{fontSize:schoolInfo.fullName.length>12?'20px':'30px'}">{{schoolInfo.fullName}}</h3>
            </div>
          </el-col>
          <el-col :span="14">
            <slot></slot>
           
          </el-col>
        <!-- </div> -->
      </el-row>

      <el-row style="overflow:hidden;">
        <div class="head-top-box fx">
         
          <el-col :span="24">
            <ul class="menu fx">
              <li
              v-for="(item,index) in navList"
              :key="index"
              @click="navClick(item,index)"
              class="menu-item" :class="a_index==index?'on':''">{{item.title}}</li>
            </ul>
          </el-col>
        </div>
      </el-row>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import mixin from "@/utils/mixin"
export default {
  props:{
    showText:{
      type:Boolean,
      default:()=>{}
    },
    sign:{
      type:String|Object,
      default:()=>{}
    }
  },
  mixins:[mixin],
  computed:mapGetters(['schoolInfo','navList','a_index']),
  data(){
    return {
      selectList:['资源名称','作者','关键词'],
      showSearchSelect: false,
      searchInput: '',
      search: 0,
      left: '0px',
      route: this.$route
    }
  },
  methods:{
    goHome(){
      this.$router.push('/')
    },
    // menuMouseOut(){
    //   if(this.$route.name.includes('search2')){
    //     this.left = '360px'
    //   }else if(this.$route.name.includes('home')){
    //     this.left = '0px'
    //   }else{
    //     this.left = '-233px'
    //   }
      
    // },
    menuMouseOver(e){
      // console.log(e.srcElement.offsetLeft);
      this.left = e.srcElement.offsetLeft + 'px'
    },
    toHigh(){
      this.$router.push(`/resourceList?t_type=${this.search}&i_keyword=${this.searchInput}`)
    }
  }
}
</script>
<style scoped>
.nav-container{
  min-height: auto;
  margin: 10px auto 10px;
}

.head-top-logo{
  height: 80px;
  justify-content: center;
}
.head-top-box{
  margin: 5px 0;
  /* align-items: flex-end; */
}
.head-top-logo img{
  width: 80px;
  border-radius: 100%;
  margin-right: 20px;
}
.head-top-logo h3{
  color: #fff;
  font-size: 36px;
  letter-spacing: 4px;
}
.head-top-school{
  cursor: pointer;
  
}
.head-top-school img{
  width: 65px;
  height: 65px;
}
.head-top-school h3{
  font-size: 30px;
  padding-left: 15px;
  letter-spacing: 3px;
  color: #333;
  user-select: none;
}

.menu{
  height: 40px;
  background: #2C8CF4;
  /* border-radius: 10px 10px 0 0; */
  justify-content: space-between;
  overflow: hidden;
  margin: 0;
}
.menu-item{
  line-height: 40px;
  color: #fff;
  font-size: 16px;
  /* padding: 0 10px; */
  flex: 1;
  text-align: center;
  cursor: pointer;
  transition: all .5s;
  position: relative;
  z-index: 3;
  white-space: nowrap;
}
.menu-item:hover{
  /* background: #0662D3; */
}
.menu-item.active{
  /* background: #0662D3; */
}
.menu-item.on{
  background: #0662D3;
  width: 150px;
  height: 100%;
  z-index: 0;
}


</style>